export default function Manifesto() {
  return (
    <section className="v3-container v3-manifesto">
      <p className="v3-manifesto-q">
        &ldquo;A receptionist, <b>distilled.</b> It answers the phone, and then
        it gets out of the way.&rdquo;
      </p>
    </section>
  );
}
